<template>
    <div class="flex flex-col border-t border-gray-200 mt-1 pt-4 | first:pt-2 first:mt-0 first:border-transparent">
        <label
            class="px-3 pb-2 uppercase text-xs tracking-wider text-gray-600"
            :class="$ui.oldFontScale ? 'text-sm' : 'text-xs'"
            data-test="option-group-label"
            v-text="label"
        />
        <slot />
    </div>
</template>

<script>
    export default {
        props: {
            label: {
                type: String,
                required: true,
            },
        },
    };
</script>
